import { render, staticRenderFns } from "./RegisterArticle.vue?vue&type=template&id=f6d753c0&scoped=true&"
import script from "./RegisterArticle.vue?vue&type=script&lang=js&"
export * from "./RegisterArticle.vue?vue&type=script&lang=js&"
import style0 from "./RegisterArticle.vue?vue&type=style&index=0&id=f6d753c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d753c0",
  null
  
)

export default component.exports